import { postalColumns, postalList } from "@/utils/postal-list";
import { Table } from "antd";
import React from "react";

const UnsureTable = (props) => {
  return (
    <Table
      className="mt-5"
      pagination={false}
      dataSource={postalList}
      columns={postalColumns}
    />
  );
};

UnsureTable.propTypes = {};

export default UnsureTable;
